import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import LabelChart from '../../components/LabelChart';
import TotalChartList from '../../components/TotalChartList';
import ValueRepresentationBox from '../../components/ValueRepresentationBox';
// import ValueRepresentationBox from '../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../constants/commonConstants';

const OperationalTravel: React.FC<{data: any[]}> = ({data}) => {
  const travelInformative = InformativeText?.NZM?.travel;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(448)}}>
        <Col span={24}>
          <TotalChartList
            chartType="barReverse"
            showTotal={false}
            keyArray={['emission per trip breakdown']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={8}>
          <LabelChart
            data={data}
            keyArray={[
              'employee transports',
              'public transports',
              'personal transports'
            ]}
            chartType="progress"
          />
        </Col>
        <Col span={16} style={{height: '100%'}}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="average emissions by trip"
                smallImage={true}
                tooltip={travelInformative.Average_emissions_by_trip}
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="total emissions of employee commute"
                smallImage={true}
                tooltip={travelInformative.Total_emissions_of_employee_commute}
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="average emissions per employee commute"
                smallImage={true}
                tooltip={
                  travelInformative.Average_emissions_per_employee_commute
                }
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="carbon intensity of travel"
                smallImage={true}
                tooltip={
                  InformativeText?.NZM?.travel?.Carbon_intensity_of_travel
                }
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="total employee commuting distance"
                smallImage={true}
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="total number of employees"
                smallImage={true}
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="distance per employee trip"
                smallImage={true}
                tooltip={
                  InformativeText?.NZM?.travel?.Distance_per_employee_trip
                }
              />
            </Col>
            <Col span={6}>
              <ValueRepresentationBox
                data={data}
                mainKey="average distance travelled per employee commute"
                smallImage={true}
                tooltip={
                  travelInformative.The_ratio_of_the_total_distance_travelled_during_business_travel
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OperationalTravel;
